import { configureLogger } from './utils/Logger';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nProvider } from './modules/i18n';
import { AuthProvider } from './modules/auth';
import { SubscriptionProvider, PaymentRequiredProvider } from './modules/subscription';
import { FilterProvider } from './modules/filters';
import { CalculatorProvider } from './modules/calculator';
import { NotificationManager } from './modules/ui';
import { CookieConsentBanner, consentService, analyticsService } from './modules/analytics';

configureLogger();

// Load GTM + Meta Pixel when user has already consented (e.g. returning visitor)
if (consentService.getConsent() === true && process.env.REACT_APP_GTM_ID) {
  analyticsService.initialize(process.env.REACT_APP_GTM_ID);
}

// Create root with React 18
const container = document.getElementById('root');
const root = createRoot(container);

// Render app with strict mode for development
root.render(
  <React.StrictMode>
    <I18nProvider initialLanguage="bg">
      <AuthProvider>
        <SubscriptionProvider>
          <PaymentRequiredProvider>
            <FilterProvider>
              <CalculatorProvider>
                <BrowserRouter>
                  <NotificationManager>
                    <App />
                    <CookieConsentBanner />
                  </NotificationManager>
                </BrowserRouter>
              </CalculatorProvider>
            </FilterProvider>
          </PaymentRequiredProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </I18nProvider>
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();
